import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const serviceGroupApiKeyStore = {
  createServiceGroup: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SERVICE_GROUP`],
    route: `/Service/Group`,
    action: 'POST',
  }),
  updateServiceGroup: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SERVICE_GROUP`],
    route: `/Service/Group`,
    action: 'PUT',
  }),
  deleteServiceGroup: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SERVICE_GROUP`, id],
    route: `/Service/Group/${id}`,
    action: 'DELETE',
  }),
  getServiceGroups: (): QueryKeyConfig => ({
    queryKey: [`GET_SERVICE_GROUPS`],
    route: `/Service/Group`,
  }),
};
